// extracted by mini-css-extract-plugin
module.exports = {"faLink":"Message_faLink__eI2pp"};